<template id="step" @payment-setup-completed="onPaymentSetupCompleted" @normal-question-confirmation="onNormalQuestionConfirmation">
    <div class="step bounceIn" :class="[step.id == 0 ? 'withimage bkg-image' : '' ]">
        <div class="container"> 
            
            <!--
            <div class="statusinfo">
                <div>step id: {{ step.id }}</div>
                <div>rightbox: {{ step.rightbox }}</div>
                <div>micro_step: {{ step.micro_step }}</div>
                <div>event_category: {{ step.event_category }}</div>
                <div>fare: {{ fare }}</div>
                <div>payment: {{ payment }}</div>
                <div>bill: {{ bill }}</div>
                <div>step type: {{ step.type }}</div>
                <div>step subtype: {{ step.subtype }}</div>
                <div>step choices: {{ step.choices }}</div>
                <div>step choices explain: {{ step.choicesexplain }}</div>
                <div>step icons: {{ step.icons }}</div>
                <div>event_labels: {{ step.event_labels }}</div>
                <div>revision: {{ revision }}</div>
            </div>
            -->
            
            
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="intro" v-html="step.intro"></div>
                </div>
            </div>

            <div class="row">
            <div :class="[ (step.rightbox !='none')&&(step.id != 0) ? 'col-lg-6 col-md-12 col-sm-12 col-xs-12' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12' ]" >

            <div class="box">
                <div class="icon colorize" v-bind:class='step.icon'></div>

                <ul v-if="step.type == 'normal'" class="questions">
                    <question v-for="( question, index ) in step.questions" :key="index" :question="question" :index="index" :choices="step.choices"
                        :choicesexplain="step.choicesexplain" :trackingclass="step.trackingclass[index]" @update-value="onUpdateAnswer"></question>
                
                    <div v-if="revision" class="text-center btn">
                        <button class="sf-btn btn--confirm" @click="onNormalQuestionConfirmation">Conferma</button>
                    </div>
                </ul>

                <ul v-else-if="step.type == 'multi'" class="questions">
                    <question-custom v-for="( question, index ) in step.questions" :key="index" :question="question"
                        :index="index" :choices="step.choices" :icons="step.icons" :subtype="step.subtype" :choicesexplain="step.choicesexplain"
                        :trackingclass="step.trackingclass[index]" @update-value="onUpdateAnswer">
                    </question-custom>
                </ul>

                <ul v-else-if="step.type == 'commodity-setup'" class="questions">
                    <question-commodity-setup v-for="( question, index ) in step.questions" :key="index" :question="question"
                        :index="index" :choices="step.choices" :icons="step.icons" :subtype="step.subtype" :preselection="preselection"
                        :trackingclass="step.trackingclass[index]" @update-value="onUpdateAnswer">
                    </question-commodity-setup>

                    <div class="text-center">
                        <button ref="commoditySetupButton" class="sf-btn btn--confirm mt" :class="[ (commoditySetupCompleted) ? '' : 'off' ]" @click="onCommoditySetupCompleted">Conferma e continua</button>  
                        <span id="confirmbutton-commoditysetup"></span>
                    </div> 
                </ul>

                <ul v-else-if="step.type == 'fare-setup'" class="questions">
                    <div v-if="step.subtype='largebuttons'">
                        <question-fare-setup v-for="( question, index ) in step.questions" :key="index" :question="question"
                            :index="index" :trackingclass="step.trackingclass[index]" @update-value="onUpdateAnswer"
                            @update-fare-setup="onUpdateFareSetup"></question-fare-setup>
                    </div>
                    <!-- la combinazione setup + normal non è contemplata al momento -->
                    <div class="text-center hidden-md hidden-sm hidden-xs">
                        <button ref="fareSetupButton" class="sf-btn btn--confirm mt" :class="[ (fareSetupCompleted) ? '' : 'off' ]" @click="onFareSetupCompleted">Conferma</button>  
                        <span id="confirmbutton-faresetup"></span>
                    </div> 
                </ul>

                <ul v-else-if="step.type == 'payment-setup'" class="questions">
                    <div v-if="step.subtype='iconbuttons'" id="paymentSetupContainer">                        
                        
                        <question-payment-setup v-for="( question, index ) in step.questions" :key="index" :question="question" :event_category="step.event_category"
                            :index="index" :choices="step.choices[index]" :icons="step.icons" :event_labels="step.event_labels"
                            :trackingclass="step.trackingclass[index]" :fare="fare" :payment="payment" :bill="bill"
                            @payment-setup-update="onPaymentSetupUpdate" @update-value="onUpdateAnswer">
                        </question-payment-setup>

                        <div class="note hidden-md hidden-sm hidden-xs">
                            Ti ricordiamo che se scegli di pagare con il bollettino, ti addebiteremo il deposito cauzionale nella prima bolletta.
                        </div> 

                        <!-- payment-summary :stepid="stepid" :fare="fare" :payment="payment" :bill="bill"></payment-summary> -->
                        <div class="text-center hidden-md hidden-sm hidden-xs">
                            <button ref="paymentSetupButton" class="sf-btn btn--confirm" :class="[ (paymentSetupCompleted) ? '' : 'off' ]" @click="onPaymentSetupCompleted">Conferma</button>  
                            <span id="confirmbutton"></span>
                        </div>      
                    </div>
                    <!-- la combinazione setup + normal non è contemplata al momento -->                     
                </ul>    
                    
            </div>

                </div>

                <div v-if="step.rightbox !='none'" class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div class="rightbox">
                        <payment-summary v-if="step.rightbox =='paymentSummary'" :stepid="stepid" :fare="fare" :payment="payment" :bill="bill" :paymentsetup="step.type" :class="step.type" :f="f" :f1="f1" :f2="f2" :gas="gas"></payment-summary>
                    </div>

                    <div v-if="step.type == 'fare-setup'" class="text-center hidden-lg">
                        <button ref="fareSetupButton" class="sf-btn btn--confirm mt" :class="[ (fareSetupCompleted) ? '' : 'off' ]" @click="onFareSetupCompleted">Conferma</button>  
                        <span id="confirmbutton-faresetup"></span>
                    </div> 

                    <div v-if="step.type == 'payment-setup'" class="text-center hidden-lg">
                        <button ref="paymentSetupButton" class="sf-btn btn--confirm" :class="[ (paymentSetupCompleted) ? '' : 'off' ]" @click="onPaymentSetupCompleted">Conferma</button>  
                        <span id="confirmbutton"></span>
                    </div>
                    <div v-if="step.type == 'payment-setup'" class="note hidden-lg">
                        Ti ricordiamo che se scegli di pagare con il bollettino, ti addebiteremo il deposito cauzionale nella prima bolletta.
                    </div> 
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import Question from './Question.vue';
import QuestionCustom from './QuestionCustom.vue';
import QuestionCommoditySetup from './QuestionCommoditySetup.vue';
import QuestionFareSetup from './QuestionFareSetup.vue';
import QuestionPaymentSetup from './QuestionPaymentSetup.vue';
import PaymentSummary from './PaymentSummary.vue'

export default {
    name: "Step",
    
    components: {
        Question,        
        QuestionCustom,
        QuestionCommoditySetup,
        QuestionFareSetup,
        QuestionPaymentSetup,
        PaymentSummary
    },

    props: ['step', 'index', 'preselection', 'fare', 'payment', 'bill', 'revision', "f", "f1", "f2", "gas"],
    data: function () {
        return {
            answer: [],
            completed: false,
            value: '',
            commoditySetupCompleted: false,
            paymentSetupCompleted: false,
            fareSetupCompleted: false,
        };
    },

    created: function () {

        this.normalQuestionConfirmation = false;
        this.stepnumber = this.step.id.length;
        this.stepid = this.step.id;

        console.log("stepid 1: ", this.step.id[1]);

        switch (this.step.id[1]) {
            case '1':
                this.totalSteps = 7;
                break
            case '2':
                this.totalSteps = 5;
            break
            case '3':
                this.totalSteps = 4;
            break;
            default:
                this.totalSteps = 10;
             break;
        }           
        this.advancement = 100/this.totalSteps*(this.step.id.length)
        
        console.log("totalSteps >", this.totalSteps);
        console.log("advancement >", this.advancement);

        document.getElementById('filler').style.width = this.advancement+'%';


       //this.$emit('fill-headerbar', this.step.label);
       this.$emit('fill-headerbar', this.step.id);


        console.log('sf-route step', 'created', 'step', this.step);

        for (let i = 0; i < this.step.questions.length; i++) {
            console.log('sf-route step', 'created', this.step);
            this.answer.push(-1)
        }
    },

    mounted: function () {

        console.log("---- STEP MOUNTED ----");
    },

    methods: {

        onUpdateAnswer: function (val) {

            console.log('sf-route step onUpdateAnswer', val);

            //$('[sf-component="cart-modal-exits"] .exit.active').removeClass('active');
            this.exitOpen = false;

            if (val) {
                console.log('sf-route step', 'onUpdateAnswer', val[0], val[1]);
                this.answer[val[0]] = val[1];
            }

            this.value = '';
            this.completed = true;
            console.log("steptype", this.step.type);


            for (let i = 0; i < this.answer.length; i++) {
                let v = this.answer[i];

                console.log('sf-route step', 'onUpdateAnswer', 'FOR', val[0], val[1]);

                if (v < 0) {
                    this.completed = false;
                    break;
                } else {
                    this.value = this.value + v;
                }
            }

            if (!this.revision) {
                if (this.completed === true) {

                    if ((this.step.type != 'commodity-setup')&&(this.step.type != 'payment-setup')&&(this.step.type != 'fare-setup')) {
                        this.$emit('step-completed', [this.index, this.value]);
                        
                    } else if (this.step.type == 'commodity-setup') {
                        this.commoditySetupCompleted = true;
                        let comm = val[1] - 1;             
                        this.$emit('update-header', this.step.choices[comm]);
                        console.log(this.$refs);

                    } else if (this.step.type == 'payment-setup') {
                        this.paymentSetupCompleted = true;
                        //console.log("tipo payment-setup");
                        //$("#paymentSetupButton").get(0).scrollIntoView();
                        console.log(this.$refs);
                        //let _this = this;
                        setTimeout (function() {
                            //_this.$refs.paymentSetupButton.scrollIntoView();
                            //$(".step.bounceIn").animate({ scrollTop: $("#paymentSetupContainer").height()+200 }, 1000);   
                            //window.location.href = "#confirmbutton";                         
                        }, 200);

                    } else if (this.step.type == 'fare-setup') {
                        this.fareSetupCompleted = true;
                        console.log(this.$refs);
                        //let _this = this;
                        setTimeout (function() {
                            //_this.$refs.paymentSetupButton.scrollIntoView();
                            //$(".step.bounceIn").animate({ scrollTop: $("#paymentSetupContainer").height()+200 }, 1000);   
                            //window.location.href = "#confirmbutton";                         
                        }, 200);
                    }

                    
                    
                } else {
                    console.log('sf-route step', 'onUpdateAnswer', 'NOT COMPLETED', this.answer, this.value);
                }
            } else if (this.revision) {
                if (this.completed === true) {

                    switch (this.step.type) {

                        case 'commodity-setup':
                            this.commoditySetupCompleted = true;
                            console.log(this.$refs);
                            break;
                        
                        case 'payment-setup':
                            this.paymentSetupCompleted = true;
                            //console.log("tipo payment-setup");
                            //$("#paymentSetupButton").get(0).scrollIntoView();
                            console.log(this.$refs);
                            var _this = this;
                            setTimeout (function() {
                                _this.$refs.paymentSetupButton.scrollIntoView();
                            }, 100);
                            break;
                        
                        case 'fare-setup':
                            this.fareSetupCompleted = true;
                            console.log(this.$refs);
                            _this = this;
                            setTimeout (function() {
                                //_this.$refs.fareSetupButton.scrollIntoView();
                            }, 100);
                            break;

                        case 'normal':
                            //console.log("case NORMAL");
                            //console.log("step questions", this.step.questions.length);
                            if (this.step.questions.length == 1) {
                                this.$emit('step-completed', [this.index, this.value]);
                            } else {
                                //console.log("qui normalQuestionConfirmation", this.normalQuestionConfirmation);
                                //this.normalQuestionConfirmation = true;
                                //console.log("qui normalQuestionConfirmation", this.normalQuestionConfirmation);
                            }
                            break;
                        default:
                            this.$emit('step-completed', [this.index, this.value]);
                        }


                    
                } else {
                    console.log('sf-route step', 'onUpdateAnswer', 'NOT COMPLETED', this.answer, this.value);
                }
            }
        },

        onUpdateFareSetup: function (val) {
            console.log('Update Fare Setup ---> ', val);
            this.fare = val;
            this.$emit('set-fare', val);
        },

        onPaymentSetupUpdate: function (what, value) {            
            if (what == 'payment') {
                this.payment = value;
                this.$emit('set-payment', value);

            } else if (what == 'bill') {
                this.bill = value;
                this.$emit('set-bill', value);
            }
            console.log('in Step - Stato di payment, bill:', this.payment, this.bill);
        },

        onPaymentSetupCompleted: function () {            
            this.$emit('step-completed', [this.index, this.value]);
        },

        onCommoditySetupCompleted: function () {            
            this.$emit('step-completed', [this.index, this.value]);
        },

        onFareSetupCompleted: function () {            
            this.$emit('step-completed', [this.index, this.value]);
        },

        onNormalQuestionConfirmation: function () {  
            this.revision = false;          
            this.$emit('step-completed', [this.index, this.value]);
        }
    }
}
</script>